<template>
  <b-modal
    id="modal-reprocessamento"
    :visible="show"
    @hidden="$emit('update:show', false)"
    title="Reprocessamento"
    centered
    hide-footer
  >
    <b-form @submit.prevent="onSubmit">
      <p>Olá! A partir de qual data você deseja reprocessar os dados?</p>

      <b-form-group label="" label-for="data-reprocessamento">
        <b-form-input
          id="data-reprocessamento"
          v-model="data"
          type="date"
          required
          :min="minDate"
        />
        <small v-if="isInvalidDate" class="text-danger">
          A data não pode ser inferior a {{ formatDate(minDate) }}.
        </small>
      </b-form-group>

      <div class="d-flex justify-content-end mt-3">
        <b-button
          variant="secondary"
          class="mr-2"
          @click="$emit('update:show', false)"
        >
          Cancelar
        </b-button>

        <b-button
          variant="primary"
          type="submit"
          :disabled="loading || !data || isInvalidDate"
          :class="{ 'btn-disabled-custom': loading || !data || isInvalidDate }"
        >
          <template v-if="loading">
            <b-spinner small class="mr-1" /> Salvando...
          </template>
          <template v-else> Salvar </template>
        </b-button>
      </div>
    </b-form>
  </b-modal>
</template>

<script>
export default {
  name: 'ReprocessamentoModal',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      data: '',
      minDate: '',
    }
  },

  created() {
    // Define o limite de 24 meses atrás
    const hoje = new Date()
    hoje.setFullYear(hoje.getFullYear() - 2)

    this.minDate = hoje.toISOString().split('T')[0]
  },

  watch: {
    show(val) {
      if (!val) this.data = ''
    },
  },

  computed: {
    isInvalidDate() {
      return this.data && this.data < this.minDate
    },
  },

  methods: {
    onSubmit() {
      if (!this.data || this.isInvalidDate) return

      this.$emit('salvar', this.data)
      this.$emit('update:show', false)
    },

    formatDate(dateStr) {
      const [y, m, d] = dateStr.split('-')
      return `${d}/${m}/${y}`
    },
  },
}
</script>

<style scoped>
.btn-disabled-custom {
  background-color: #cfcfcf !important;
  border-color: #bdbdbd !important;
  color: #666 !important;
  cursor: not-allowed !important;
  opacity: 0.8;
}
</style>
